import logo from '../images/logo.png'
import { useNavigate } from 'react-router-dom';
export default function CmsBar({user, setUser}) {
	const navigate = useNavigate();

	const logout = () => {
		localStorage.removeItem('user');
		window.location.href = '/login';
	}
	return (
		<div className={`nav`}>
			<div className="flex flex__row justify__cennter">
				<a className="nav__logo btn btn__transparent" onClick={() => navigate(`/`)}>
					<img src={logo} width={250} />
				</a>
				{ user !== null &&
					<>
						<div className="bar__vertical"></div>
						<a className="btn btn__transparent" onClick={() => navigate(`/create`)}>
							<div className="mtop--5">
								<span className="material-icons font__30">home</span>
								Dashboard
							</div>
						</a>
					</>
				}
			</div>
			{user  ?
				<div className="nav__items">
					<a onClick={() => navigate(`/profile`)} className="btn btn__secondary-outline btn__rounded">
						<span className="material-icons">
							account_circle
						</span>
						<span className="capitalize">{user?.user?.name} {user?.user?.surname}</span>
					</a>
					<a onClick={logout} className="btn btn__transparent btn__rounded text__primary">
						<span className="material-icons">logout</span>
						Logout
					</a>
				</div>
				:
				<div className="nav__items"></div>
			}
		</div>
	)
}